class PathDispatcher {

  static scoring (transactionId = '') {
    if (transactionId) {
      return `/scoring/${transactionId}`
    }
    return `/scoring`
  }

  static scoringSignature () {
    return `/scoring/signature`
  }


  static evaluate () {
    return `/evaluate`
  }

  static signature () {
    return `/signature`
  }

  static results () {
    return `/results`
  }

  static resultsAppend () {
    return `/results/append`
  }

  static account () {
    return `/account`
  }

  static accountStatus () {
    return `/account/status`
  }

  static models () {
    return `/models`
  }

  static modelsBundling () {
    return `/models/bundling`
  }

}


export {PathDispatcher}



// WEBPACK FOOTER //
// ./src/modules/dispatcher.js